import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetCustomPulldownOptionsAll } from '@/context/services/transaction_items/Detail/TransactionItemDetail.service';
import { formatPulldownOptionForExport } from '@/features/InvoiceReport/Edit/components/utils/customTransactionItems';
import { ApGeneralInputOption } from 'ap-openapi';
import { useMemo } from 'react';

export const useCustomPulldownOptions = (id?: string) => {
  const _options = useGetCustomPulldownOptionsAll(id);
  const options = useMemo(
    () =>
      _options.map((option) => ({
        ...option,
        display_name: formatPulldownOptionForExport(option.label, option.code),
      })),
    [_options]
  );

  const findLabelById = useFindById<ApGeneralInputOption, 'id', 'label'>(
    options,
    {
      key: 'id',
      return: 'label',
      defaultVal: '',
    }
  );

  const findCodeById = useFindById<ApGeneralInputOption, 'id', 'code'>(
    options,
    {
      key: 'id',
      return: 'code',
      defaultVal: '',
    }
  );

  const findDisplayNameById = useFindById<
    (typeof options)[number],
    'id',
    'display_name'
  >(options, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });

  const findIdByDisplayName = useFindByName<
    (typeof options)[number],
    'display_name',
    'id'
  >(options, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });

  return {
    id,
    options,
    findLabelById,
    findCodeById,
    findDisplayNameById,
    findIdByDisplayName,
  };
};
